// 项目内部审核
<template>
  <div class="projectFormLess" v-if="isComponentsShow">
    <!-- tab栏 -->
    <ul class="topTabs">
      <li
        @click="handleTopBarClikc('1')"
        :class="topBarActive==='1'?'topBarActiveBlue':''"
      >项目内部审核意见表</li>
      <li @click="handleTopBarClikc('2')" :class="topBarActive==='2'?'topBarActiveBlue':''">修改回复表</li>
    </ul>
    <!-- {1}项目内部审核意见表 -->
    <div class="tabsItem" v-if="topBarActive==='1'">
      <!-- 第一行-项目名称 -->
      <div class="oneRow" style="margin-bottom:35px">
        <div class="leftLabel">
          <img style="width:16px" src="../../assets/image/icon_xiangm@2x.png" alt />
          <span>项目名称</span>
        </div>
        <div class="rightInput">
          <span class="isNotSubmitSpan">{{S_project_name}}</span>
        </div>
      </div>
      <!-- 第二行-项目审核内容 -->
      <div class="oneRow" style="margin-bottom:23px">
        <div class="leftLabel" style="width:300px">
          <img style="width:17px" src="../../assets/image/icon_shenh@2x.png" alt />
          <span>项目审核内容</span>
        </div>
      </div>
      <div class="ProjectTextAreaBox" style="margin-bottom:50px;">
        <el-table
          :data="tableData1"
          style="width: 100%"
          border
          :header-cell-style="{background:'#F4F5F6'}"
        >
          <el-table-column show-overflow-tooltip align="center" prop="id" label="序号" width="50"></el-table-column>
          <el-table-column show-overflow-tooltip align="center" prop="content" label="内容"></el-table-column>
          <el-table-column show-overflow-tooltip align="center" label="审核意见" width="350">
            <template slot-scope="scope">
              <div class="auditOpinion">
                <el-radio-group
                  :disabled="!isSubmit1"
                  v-model="scope.row.radio"
                  @change="handleChange"
                >
                  <el-radio :label="'0'">是</el-radio>
                  <el-radio :label="'1'">否</el-radio>
                  <el-radio :label="'2'">其他</el-radio>
                </el-radio-group>
                <el-input :disabled="!isSubmit1" v-model="scope.row.other"></el-input>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 第三行--文件格式审查意见 -->
      <!-- <div class="oneRow" style="margin-bottom:23px">
        <div class="leftLabel" style="width:300px">
          <img style="width:17px" src="../../assets/image/icon_yx@2x.png" alt />
          <span>文件格式审查意见</span>
        </div>
      </div>
      <div class="ProjectTextAreaBox" style="margin-bottom:50px;">
        <el-table
          :data="tableData2"
          style="width: 100%"
          border
          :header-cell-style="{background:'#F4F5F6'}"
        >
          <el-table-column show-overflow-tooltip align="center" prop="id" label="序号" width="50"></el-table-column>
          <el-table-column show-overflow-tooltip align="center" prop="content" label="内容"></el-table-column>
          <el-table-column show-overflow-tooltip align="center" label="审核意见" width="250">
            <template slot-scope="scope">
              <div
                v-if="scope.row.id===4 || scope.row.id===5 "
                class="auditOpinion"
                style="justify-content: center;"
              >
                <el-radio-group
                  :disabled="!isSubmit1"
                  v-model="scope.row.radio"
                  @change="handleChange"
                >
                  <el-radio :label="'0'">是</el-radio>
                  <el-radio :label="'1'">否</el-radio>
                </el-radio-group>
              </div>
              <div v-else class="auditOpinion" style="justify-content: center;">
                <el-radio-group
                  :disabled="!isSubmit1"
                  v-model="scope.row.radio"
                  @change="handleChange"
                >
                  <el-radio :label="'0'">符合</el-radio>
                  <el-radio :label="'1'">不符合</el-radio>
                </el-radio-group>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>-->
      <!-- 第四行--项目内容审查意见 -->
      <div class="oneRow" style="margin-bottom:23px">
        <div class="leftLabel" style="width:300px">
          <img style="width:15px" src="../../assets/image/icon_yijian@2x.png" alt />
          <span>项目内容审查意见</span>
        </div>
      </div>
      <div class="ProjectTextAreaBox" style="margin-bottom:31px;">
        <el-input
          :disabled="!isSubmit1"
          v-model="addFormData1.review_comments"
          type="textarea"
          :autosize="{minRows: 3}"
        ></el-input>
      </div>
      <!-- 签字 -->
      <!-- <div class="writeName" style="margin-bottom:25px">
        <img style="width:16px;margin-right:10px" src="../../assets/image/icon_qian@2x.png" alt />
        <span style="width:220px">被评价单位提供材料人员签字</span>
        <img
          v-if="!addFormData1.sign_audit"
          @click="handleReceiverFlag1"
          style="width:66px;"
          src="../../assets/image/zaixianqianm@2x.png"
          alt
        />
        <img
          v-if="addFormData1.sign_audit"
          @click="handleReceiverFlag1(addFormData1.sign_audit)"
          style="width:66px;"
          :src="addFormData1.sign_audit"
          alt
        />
      </div>-->
      <!-- 第五行--上传附件 -->
      <div class="oneRow">
        <div class="leftLabel upLoadLabel">
          <img style="width:14px" src="../../assets/image/icon_fj@2x.png" alt />
          <span>上传附件</span>
        </div>
        <div class="rightInput">
          <upload-file
            :isSubmit="isSubmit1"
            :imgList="this.addFormData1.annex"
            :detailsImgList="detailsImgList1"
            @my-upload-change="upLoadChange1"
          ></upload-file>
        </div>
      </div>
      <div class="oneRow" style="margin-bottom:30px">
        <div class="leftLabel"></div>
        <div class="rightInput">
          <span
            style="color:rgb(245, 95, 95);font-size:12px;"
          >*请上传项目内部审核表，以及送审版、内审版和备案版报告,内部审核表模板文件：</span>
          <a style="font-size:14px;" href="http://control.sxpz.vip/Template/项目内部审核表.doc">项目内部审核表.doc</a>
        </div>
      </div>

      <!-- 审批备注 -->
      <div
        class="oneRow"
        style="margin-bottom:35px;margin-top:20px"
        v-if="addFormData1.is_approve==1"
      >
        <div class="leftLabel">
          <img style="width:17px" src="../../assets/image/icom_jj@2x.png" alt />
          <span>审批备注</span>
        </div>
        <div class="rightInput">
          <el-input v-model="approval_remark1"></el-input>
        </div>
      </div>

      <!-- 按钮行 -->
      <div class="btnRow">
        <el-button @click="handleSubmit1('1')" v-if="addFormData1.is_edit!='1'">保存草稿</el-button>
        <el-button
          v-if="addFormData1.withdraw_status=='1'"
          @click="handleProjectWithDraw1"
          style="background-color:rgb(255, 26, 26);"
        >撤回</el-button>
        <el-button
          style="background-color:#40A0F2"
          @click="handleSubmit1('0')"
          v-if="addFormData1.is_edit!='1'"
        >提交</el-button>
        <el-button
          v-if="addFormData1.is_approve==1"
          @click="handleExamine1('-1')"
          style="background-color:#f4a029"
        >驳回</el-button>
        <el-button
          v-if="addFormData1.is_approve==1"
          @click="handleExamine1('1')"
          style="background-color:#40A0F2"
        >审批通过</el-button>
      </div>
      <!-- 按钮行 -->
    </div>
    <!-- {2}修改回复表 -->
    <div class="tabsItem" v-if="topBarActive==='2'">
      <!-- 第一行-项目名称 -->
      <div class="oneRow" style="margin-bottom:35px">
        <div class="leftLabel">
          <img style="width:16px" src="../../assets/image/icon_xiangm@2x.png" alt />
          <span>项目名称</span>
        </div>
        <div class="rightInput">
          <span class="isNotSubmitSpan">{{S_project_name}}</span>
        </div>
      </div>
      <!-- 第二行--修改记录 -->
      <div class="oneRow" style="margin-bottom:23px">
        <div class="leftLabel" style="width:300px">
          <img style="width:15px" src="../../assets/image/icon_xgjl@2x.png" alt />
          <span>修改记录</span>
        </div>
      </div>
      <div class="ProjectTextAreaBox" style="margin-bottom:31px;">
        <el-input
          v-model="addFormData2.modification_record"
          :disabled="!isSubmit2"
          type="textarea"
          :autosize="{minRows: 3}"
        ></el-input>
      </div>
      <!-- 签字 -->
      <!-- <div class="writeName" style="margin-bottom:10px">
        <img style="width:16px;margin-right:10px" src="../../assets/image/icon_qian@2x.png" alt />
        <span style="width:100px">修改人确认</span>
        <img
          v-if="!addFormData2.sign_modifier"
          @click="handleReceiverFlag2"
          style="width:66px;"
          src="../../assets/image/zaixianqianm@2x.png"
          alt
        />
        <img
          v-if="addFormData2.sign_modifier"
          @click="handleReceiverFlag2(addFormData2.sign_modifier)"
          style="width:66px;"
          :src="addFormData2.sign_modifier"
          alt
        />
      </div>
      <div class="writeName" style="margin-bottom:25px">
        <img style="width:16px;margin-right:10px" src="../../assets/image/icon_qian@2x.png" alt />
        <span style="width:130px">审核负责人确认</span>
        <img
          v-if="!addFormData2.confirm_sign_audit"
          @click="handleReceiverFlag3"
          style="width:66px;"
          src="../../assets/image/zaixianqianm@2x.png"
          alt
        />
        <img
          v-if="addFormData2.confirm_sign_audit"
          @click="handleReceiverFlag3(addFormData2.confirm_sign_audit)"
          style="width:66px;"
          :src="addFormData2.confirm_sign_audit"
          alt
        />
      </div>-->
      <!-- 第三行--日期 -->
      <div class="rightTimeRow" style="margin-bottom:30px">
        <img style="width:17px" src="../../assets/image/icon_riqi@2x.png" alt />
        <span style="color:#333;margin:0 10px">日期</span>
        <el-date-picker
          :disabled="!isSubmit2"
          v-model="addFormData2.confirm_date"
          type="date"
          :placeholder="isSubmit2 ? '选择日期' : ''"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </div>
      <!-- 第四行--上传附件 -->
      <div class="oneRow">
        <div class="leftLabel upLoadLabel">
          <img style="width:14px" src="../../assets/image/icon_fj@2x.png" alt />
          <span>上传附件</span>
        </div>
        <div class="rightInput">
          <upload-files
            :isSubmit="isSubmit2"
            :imgList="this.addFormData2.confirm_annex"
            :detailsImgList="detailsImgList2"
            @my-upload-change="upLoadChange2"
          ></upload-files>
        </div>
      </div>

      <!-- 审批备注 -->
      <div
        class="oneRow"
        style="margin-bottom:35px;margin-top:20px"
        v-if="addFormData2.is_approve==1"
      >
        <div class="leftLabel">
          <img style="width:17px" src="../../assets/image/icom_jj@2x.png" alt />
          <span>审批备注</span>
        </div>
        <div class="rightInput">
          <el-input v-model="approval_remark1"></el-input>
        </div>
      </div>

      <!-- 按钮行 -->
      <div class="btnRow">
        <el-button @click="handleSubmit2('1')" v-if="addFormData2.is_edit!='1'">保存草稿</el-button>
        <el-button
          v-if="addFormData2.withdraw_status=='1'"
          @click="handleProjectWithDraw2"
          style="background-color:rgb(255, 26, 26);"
        >撤回</el-button>
        <el-button
          style="background-color:#40A0F2"
          @click="handleSubmit2('0')"
          v-if="addFormData2.is_edit!='1'"
        >提交</el-button>
        <el-button
          v-if="addFormData2.is_approve==1"
          @click="handleExamine2('-1')"
          style="background-color:#f4a029"
        >驳回</el-button>
        <el-button
          v-if="addFormData2.is_approve==1"
          @click="handleExamine2('1')"
          style="background-color:#40A0F2"
        >审批通过</el-button>
      </div>
      <!-- 按钮行 -->
    </div>
    <!-- 签名组件 -->
    <sign-dialog
      @wirtDoen="handleWriteDone1"
      :visible.sync="receiverSignFlag1"
      @change="handleReceiverSign"
    ></sign-dialog>
    <sign-dialog
      @wirtDoen="handleWriteDone2"
      :visible.sync="receiverSignFlag2"
      @change="handleReceiverSign"
    ></sign-dialog>
    <sign-dialog
      @wirtDoen="handleWriteDone3"
      :visible.sync="receiverSignFlag3"
      @change="handleReceiverSign"
    ></sign-dialog>
    <!-- 签名组件 -->

    <!-- 查看进度 -->
    <project-flow
      class="modifyFlow"
      v-if="this.addFormData1.approval_log && this.addFormData1.approval_log.length>0 && topBarActive==='1'"
      :projectFlowLog="this.addFormData1.approval_log"
      :projectName="this.addFormData1.project_name"
      :companyName="this.addFormData1.company_name"
      :projectId="this.addFormData1.project_id"
      :stageCode="'311'"
    ></project-flow>
    <project-flow
      class="modifyFlow"
      v-if="this.addFormData2.approval_log && this.addFormData2.approval_log.length>0 && topBarActive==='2'"
      :projectFlowLog="this.addFormData2.approval_log"
      :projectName="this.addFormData2.project_name"
      :companyName="this.addFormData2.company_name"
      :projectId="this.addFormData2.project_id"
      :stageCode="'312'"
    ></project-flow>
    <go-finance
      class="modifyFlow"
      v-if="this.addFormData1.approval_log && this.addFormData1.approval_log.length>0 && topBarActive==='1'"
      :projectId="this.addFormData1.project_id"
    ></go-finance>
    <go-finance
      class="modifyFlow"
      v-if="this.addFormData2.approval_log && this.addFormData2.approval_log.length>0 && topBarActive==='2'"
      :projectId="this.addFormData2.project_id"
    ></go-finance>
    <!-- 签名详情弹窗 -->
    <el-dialog
      :visible.sync="showDetailsDia"
      width="50%"
      class="addUserDia imgDetailsDia"
      :before-close="showDetailsDiaClose"
    >
      <div class="diaContainer">
        <img :src="showDetailsSign" alt />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ProjectFlow from '../ProjectFlow'
import SignDialog from '../SignDialog'
import GoFinance from '../GoFinance'
import UploadFile from '../UploadFile'
import UploadFiles from '../UploadFile'
export default {
  data() {
    return {
      tiemID: null,
      timeDou: 100,
      showDetailsSign: '',
      showDetailsDia: false,

      S_project_name: '',
      approval_remark1: '',
      approval_remark2: '',
      isSubmit1: true,
      isSubmit2: true,
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      // 文件上传组件
      detailsImgList1: [],
      detailsImgList2: [],
      submitImgList1: [],
      submitImgList2: [],
      // 文件上传组件
      // 签名
      receiverSignFlag1: false,
      receiverSignFlag2: false,
      receiverSignFlag3: false,
      writeDoneImg1: '',
      writeDoneImg2: '',
      writeDoneImg3: '',
      // 签名
      addFormData1: {
        annex: '',
        // sign_audit: '',
        // 项目审核内容
        audit_content: '',
        // 文件格式审查意见
        // document_format: '',
        // 项目内容审查意见
        review_comments: '',
      },
      addFormData2: {
        confirm_date: '',
        modification_record: '',
        confirm_annex: '',
        // sign_modifier: '',
        // confirm_sign_audit: '',
      },
      topBarActive: '1',
      infop: '',
      member_id: '',
      token: '',
      value: '',
      tableData1: [
        {
          id: 1,
          // content: '评价依据是否充分、有效',
          content: '报告封面、著录项是否符合导则要求',
          radio: '0',
          other: '',
        },
        {
          id: 2,
          // content: '危险有害因素识别是否全面',
          content: '评价依据是否充分有效',
          radio: '0',
          other: '',
        },
        {
          id: 3,
          // content: '评价单元划分是否合理',
          content: '危险有害因素识别是否全面',
          radio: '0',
          other: '',
        },
        {
          id: 4,
          // content: '评价方法选择是否适当',
          content: '评价单元划分是否合理',
          radio: '0',
          other: '',
        },
        {
          id: 5,
          // content: '对策措施是否可行',
          content: '评价方法选择是否适当',
          radio: '0',
          other: '',
        },
        {
          id: 6,
          // content: '结论是否正确',
          content: '对策措施是否可行',
          radio: '0',
          other: '',
        },
        {
          id: 7,
          // content: '结论是否正确',
          content: '结论是否正确',
          radio: '0',
          other: '',
        },
        {
          id: 8,
          // content: '结论是否正确',
          content: '格式是否符合要求',
          radio: '0',
          other: '',
        },
        {
          id: 9,
          // content: '结论是否正确',
          content: '文字是否准确',
          radio: '0',
          other: '',
        },
      ],
      // tableData2: [
      //   {
      //     id: 1,
      //     content: '文件编排格式',
      //     radio: '1',
      //   },
      //   {
      //     id: 2,
      //     content: '文件编号、署名或签名',
      //     radio: '1',
      //   },
      //   {
      //     id: 3,
      //     content: '文字内容和图、表编排',
      //     radio: '1',
      //   },
      //   {
      //     id: 4,
      //     content: '文字差错率是否在公司控制指标内（0.3%）',
      //     radio: '1',
      //   },
      //   {
      //     id: 5,
      //     content: '技术文件附录、附件是否齐全、规范、适宜（初审）',
      //     radio: '1',
      //   },
      // ],
      isComponentsShow: false,
    }
  },
  methods: {
    // *撤回项目
    async handleProjectWithDraw1() {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)

        param.append('project_id', this.details_project_id)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/withdraw',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getProjectDetails1()
      }, this.timeDou)
    },
    // *撤回项目
    async handleProjectWithDraw2() {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)

        param.append('project_id', this.details_project_id)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/withdraw',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getProjectDetails2()
      }, this.timeDou)
    },
    selectPermitChange() {
      if (this.addFormData.permit_type == '1') {
        this.addFormData.permit_type_sub = ''
      }
      if (this.addFormData.permit_type == '2') {
        this.addFormData.permit_type_sub = '1'
      }
    },
    // *审批提交-2修改回复表
    async handleExamine2(val) {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('approval_status', val)
        param.append('remark', this.approval_remark1)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/audit2_approval',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        // this.$router.push('/project/index')
        this.getProjectDetails2()
      }, this.timeDou)
    },
    // *审批提交-1
    async handleExamine1(val) {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('approval_status', val)
        param.append('remark', this.approval_remark1)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/audit1_approval',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        // this.$router.push('/project/index')
        this.getProjectDetails1()
      }, this.timeDou)
    },
    // *编辑提交-2修改回复表
    async handleSubmit2(val) {
      if (
        this.addFormData2.confirm_date == 'null' ||
        this.addFormData2.confirm_date == null
      ) {
        this.addFormData2.confirm_date = ''
      }
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('is_draft', val)

        param.append(
          'modification_record',
          this.addFormData2.modification_record
        )
        // param.append('sign_modifier', this.addFormData2.sign_modifier)
        // param.append('confirm_sign_audit', this.addFormData2.confirm_sign_audit)
        param.append('confirm_date', this.addFormData2.confirm_date)
        param.append('confirm_annex', JSON.stringify(this.submitImgList2))

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/audit2',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        // this.$router.push('/project/index')
        this.getProjectDetails2()
      }, this.timeDou)
    },
    // *编辑提交-1内部审核意见表
    async handleSubmit1(val) {
      this.addFormData1.audit_content = JSON.stringify(this.tableData1)
      // this.addFormData1.document_format = JSON.stringify(this.tableData2)
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('is_draft', val)

        param.append('audit_content', this.addFormData1.audit_content)
        // param.append('document_format', this.addFormData1.document_format)
        param.append('review_comments', this.addFormData1.review_comments)

        // param.append('sign_audit', this.addFormData1.sign_audit)
        param.append('annex', JSON.stringify(this.submitImgList1))

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/audit1',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        // this.$router.push('/project/index')
        this.getProjectDetails1()
      }, this.timeDou)
    },
    // *获取详情-2修改回复表
    async getProjectDetails2() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('project_id', this.details_project_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/audit2_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      // 判断是不是首次到此流程
      if (res.datas.info.is_new != 1) {
        this.addFormData2 = res.datas.info
      } else {
        this.addFormData2.is_edit = res.datas.info.is_edit
      }
      // 判断禁用
      if (
        this.addFormData2.is_draft != '1' &&
        this.addFormData2.is_edit == '1'
      ) {
        this.isSubmit2 = false
      } else {
        this.isSubmit2 = true
      }
      // 项目名称
      this.S_project_name = res.datas.info.project_name
      // 判断文件上传
      if (this.addFormData2.confirm_annex) {
        this.detailsImgList2 = this.addFormData2.confirm_annex
        this.submitImgList2 = this.addFormData2.confirm_annex
      }
      if (
        this.addFormData2.modification_record == 'undefined' ||
        this.addFormData2.modification_record == 'null' ||
        this.addFormData2.modification_record == null
      ) {
        this.addFormData2.modification_record = ''
      }
      // 判断签名
      // if (this.addFormData2.sign_modifier == 'undefined') {
      //   this.addFormData2.sign_modifier = ''
      // }
      // if (this.addFormData2.confirm_sign_audit == 'undefined') {
      //   this.addFormData2.confirm_sign_audit = ''
      // }
      // 判断日期
      if (this.addFormData2.confirm_date == 'null') {
        this.addFormData2.confirm_date = ''
      }
      this.isComponentsShow = true
      console.log('内部审核-2修改回复表', this.addFormData2)
    },
    // *获取详情-1内部审核意见表
    async getProjectDetails1() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('project_id', this.details_project_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/audit1_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      // 判断是不是首次到此流程
      if (res.datas.info.is_new != 1) {
        this.addFormData1 = res.datas.info
      } else {
        this.addFormData1.is_edit = res.datas.info.is_edit
      }
      // 判断禁用
      if (
        this.addFormData1.is_draft != '1' &&
        this.addFormData1.is_edit == '1'
      ) {
        this.isSubmit1 = false
      } else {
        this.isSubmit1 = true
      }
      // 项目名称
      this.S_project_name = res.datas.info.project_name
      // 判断文件上传
      if (this.addFormData1.annex) {
        this.detailsImgList1 = this.addFormData1.annex
        this.submitImgList1 = this.addFormData1.annex
      }
      // 判断表格
      if (this.addFormData1.audit_content) {
        this.tableData1 = this.addFormData1.audit_content
      }
      // if (this.addFormData1.document_format) {
      //   this.tableData2 = this.addFormData1.document_format
      // }
      // 判断签名
      if (this.addFormData1.sign_receiving == 'undefined') {
        this.addFormData1.sign_receiving = ''
      }
      this.isComponentsShow = true
      console.log('内部审核-1内部审核意见表', this.addFormData1)
    },
    // 文件上传
    upLoadChange1(data) {
      console.log('文件列表1', data)
      this.submitImgList1 = data
    },
    upLoadChange2(data) {
      console.log('文件列表2', data)
      this.submitImgList2 = data
    },
    // 签名
    handleWriteDone1(data) {
      this.addFormData1.sign_audit = data
    },
    handleWriteDone2(data) {
      this.addFormData2.sign_modifier = data
    },
    handleWriteDone3(data) {
      this.addFormData2.confirm_sign_audit = data
    },
    handleReceiverFlag1(url) {
      if (!this.isSubmit1) {
        if (url) {
          this.showDetailsSign = url
          this.showDetailsDia = true
        }
        return
      }
      this.receiverSignFlag1 = true
    },
    handleReceiverFlag2(url) {
      if (!this.isSubmit2) {
        if (url) {
          this.showDetailsSign = url
          this.showDetailsDia = true
        }
        return
      }
      this.receiverSignFlag2 = true
    },
    handleReceiverFlag3(url) {
      if (!this.isSubmit2) {
        if (url) {
          this.showDetailsSign = url
          this.showDetailsDia = true
        }
        return
      }
      this.receiverSignFlag3 = true
    },
    handleReceiverSign() {},
    // 签名
    handleChange() {
      console.log(this.tableData1)
    },
    handleTopBarClikc(val) {
      if (this.details_project_status == '311') return
      if (val == '1') {
        this.getProjectDetails1()
      }
      if (val == '2') {
        this.getProjectDetails2()
      }
      this.topBarActive = val
    },
    async handleBefore(file) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('file', file)
      const { data: res } = await this.$axios({
        method: 'post',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        url: '/api/User/uploadImg',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success('上传成功')
      this.editUserForm.avatar = res.datas.img_url
      console.log('头像', this.editUserForm.avatar)
    },
    showDetailsDiaClose() {
      this.showDetailsDia = false
    },
    async getProjectStatus() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('project_id', this.details_project_id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/get_project_status',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.details_project_status = res.datas.project_status
      if (this.details_project_status) {
        if (this.details_project_status == '311') {
          this.topBarActive = '1'
        }
        if (this.details_project_status == '312') {
          this.topBarActive = '2'
        }
      }
      if (this.details_project_status && this.details_project_id) {
        if (this.details_project_status == '311') {
          this.getProjectDetails1()
        } else if (this.details_project_status == '312') {
          this.getProjectDetails1()
          this.getProjectDetails2()
        } else {
          this.getProjectDetails1()
        }
      }
    },
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    this.details_project_id = this.$route.query.project_id || ''
    if (this.details_project_id) {
      this.getProjectStatus()
    }
  },
  components: {
    SignDialog,
    UploadFile,
    UploadFiles,
    ProjectFlow,
    GoFinance,
  },
}
</script>
<style lang="less" scoped>
@import url(../project/projectForm.less);
/deep/.modifyFlow .projectFlowBtn {
  top: 70px !important;
}
/deep/.modifyFlow .goFinanceBtn {
  top: 120px !important;
}
</style>